import {getHost} from './common'
// import {apiLoginout} from './apis'

export async function removeSessoin(){
    window.localStorage.removeItem('app_userName')
    window.localStorage.removeItem('app_token')
}

export async function toLogin(){
    // await apiLoginout()
    await removeSessoin()
    let loginUrl = getHost() + '/review/login'
    window.location.href = 
        `https://jaccount.sjtu.edu.cn/oauth2/logout?client_id=${process.env.VUE_APP_JACCOUNT_CLIENT_ID}&post_logout_redirect_uri=${encodeURIComponent(loginUrl)}`
}

export function timeStemp (date = ''){
    if(date !== ''){
        return (new Date(date)).getTime()
    }else{
        return (new Date()).getTime()
    }
}

export function getStorageRoundInfo (){
    if(window.localStorage.round_info){
        return JSON.parse(window.localStorage.round_info)
    }else{
        window.location.href="/report/form"
    }
}
